import axios from '@/plugins/axios'

class AuthService {
  async login(user) {
    const originData = `${process.env.VUE_APP_CLIENT_ID}:${process.env.VUE_APP_CLIENT_SECRET}`
    const encodeData = btoa(originData)

    const formData = new FormData()
    formData.append('username', user.id)
    formData.append('password', user.password)
    formData.append('grant_type', 'password')

    const { data } = await axios.post('/oauth/token', formData, {
      headers: {
        Authorization: `Basic ${encodeData}`,
        Accept: '*/*'
      }
    })
    return data
  }

  async register(user) {
    const formData = new FormData()
    formData.append('userId', user.userId)
    formData.append('password', user.password)
    if (user.type) {
      formData.append('type', user.type)
    }

    const { data } = await axios.post('/sum/api/users', formData).then()
    return data
  }

  async checkAccessToken(accessToken) {
    const formData = new FormData()
    formData.append('token', accessToken)

    const { data } = await axios.post('/oauth/check_token', formData).then()
    return data
  }

  async refreshToken(refreshToken) {
    const originData = `${process.env.VUE_APP_CLIENT_ID}:${process.env.VUE_APP_CLIENT_SECRET}`
    const encodeData = btoa(originData)

    const formData = new FormData()
    formData.append('refresh_token', refreshToken)
    formData.append('grant_type', 'refresh_token')

    const { data } = await axios
      .post('/oauth/token', formData, {
        headers: {
          Authorization: `Basic ${encodeData}`,
          Accept: '*/*'
        }
      })
      .then()
    return data
  }

  logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('isUserPermitAll')
  }

  async socialLogin(account) {
    const originData = `${process.env.VUE_APP_CLIENT_ID}:${process.env.VUE_APP_CLIENT_SECRET}`
    const encodeData = btoa(originData)

    const formData = new FormData()
    formData.append('userId', account.userID)
    formData.append('password', '')
    formData.append('type', account.type)

    const { data } = await axios.post('/sum/api/token', formData, {
      headers: {
        Authorization: `Basic ${encodeData}`,
        Accept: '*/*'
      }
    })
    return data
  }
}

export default new AuthService()
